export default __webpack_public_path__ + "locales/sl/Payments.json?hash=2a8712e774e364b201357ec8f3f10d59";